<template>
  <div>
    <v-tabs
      ref="tabs"
      v-model="active"
    >
      <v-tab
        v-for="item in tabItems"
        :key="item.name"
        class="divider font-black"
      >
        {{ item.name }}
      </v-tab>
    </v-tabs>

    <div
      v-if="loading"
      align="center" 
      justify="center"
    >
      <v-progress-linear
        indeterminate
        color="primary"
      />
    </div> 
    <div v-else>
      <v-tabs-items
        v-model="active"
        style="background:transparent"
      >
        <!-- Payroll -->
        <v-tab-item>
          <v-autocomplete
            v-model="payrollReport"
            label="Report Types"
            :items="payrollReportTypes"
            item-text="name"
            class="pt-5 px-3"
            autofocus
            style="background:white"
          />
          <payroll-report-c-p-2-2
            v-if="payrollReport === 'CP22'"
            :companies="companies"
            class="mb-2"
          />
          <payroll-report-c-p-2-2-a
            v-if="payrollReport === 'CP22A'"
            :companies="companies"
            class="mb-2"
          />        
          <payroll-report-income-tax-detail
            v-if="payrollReport === 'CP8D'"
            :years="years"
            :companies="companies"
            class="mb-2"
          />        
          <payroll-report-form-e-excel
            v-if="payrollReport === 'Form E Data'"
            :years="years"
            :companies="companies"
            class="mb-2"
          />
          <payroll-report-p-c-b2
            v-if="payrollReport === 'PCB(II)'"
            :years="years"
            :companies="companies"
            class="mb-2"
          />
          <payroll-report-ea-form
            v-if="payrollReport === 'EA Form'"
            :years="years"
            :companies="companies"
            class="mb-2"
          />
          <payroll-report-lampiran-b
            v-if="payrollReport === 'Lampiran B'"
            :years="years"
            :companies="companies"
            class="mb-2"
          />
          <payroll-report-epf
            v-if="payrollReport === 'Employee EPF Reports'"
            :companies="companies"
            class="mb-2"
          />
          <payroll-report-previous-remuneration
            v-if="payrollReport === 'Previous Remuneration YTD (TP3) Reports'"
            :companies="companies"
            class="mb-2"
          />        
        </v-tab-item>

        <!-- Audit Reports -->
        <v-tab-item
          class="mt-1"
          style="background:white"
        >
          <v-autocomplete
            v-model="auditReport"
            label="Report Types"
            :items="auditReportTypes"
            item-text="name"
            class="pt-5 px-3"
            autofocus
            style="background:white"
          />
          <payroll-report-audit-form
            v-if="auditReport"
            :audit-report="auditReport"
            :companies="companies"
            :payroll-periods="payrollPeriods"
            class="mb-2"
          />
        </v-tab-item>

        <!-- PCB Statement -->
        <v-tab-item
          class="mt-1"
          style="background:white"
        >    
          <pcb-statement-container-view />
        </v-tab-item>

        <!-- PCB Arrear -->
        <v-tab-item
          class="mt-1"
          style="background:white"
        >   
          <pcb-arrear-container-view />
        </v-tab-item>
      </v-tabs-items>
    <!-- -->
    </div>
  </div>
</template>

<script>
  export default {
    components: {
      PayrollReportCP22: () => import('@/components/hris/payroll/report/income-tax-report/CP22'),
      PayrollReportCP22A: () => import('@/components/hris/payroll/report/income-tax-report/CP22A'),      
      PayrollReportIncomeTaxDetail: () => import('@/components/hris/payroll/report/income-tax-report/IncomeTaxDetail'),
      PayrollReportFormEExcel: () => import('@/components/hris/payroll/report/income-tax-report/FormEExcel'),
      PayrollReportPCB2: () => import('@/components/hris/payroll/report/income-tax-report/PCB2'),
      PayrollReportEaForm: () => import('@/components/hris/payroll/report/income-tax-report/EaForm'),
      PayrollReportLampiranB: () => import('@/components/hris/payroll/report/income-tax-report/LampiranB'),
      PayrollReportEpf: () => import('@/components/hris/payroll/report/income-tax-report/Epf'),
      PayrollReportPreviousRemuneration: () => import('@/components/hris/payroll/report/income-tax-report/PreviousRemuneration'),
      
      PayrollReportAuditForm: () => import('@/components/hris/payroll/report/audit-report/AuditFormCard'),

      PcbArrearContainerView: () => import('@/components/hris/payroll/pcb-two/PcbArrearContainerView'),
      PcbStatementContainerView: () => import('@/components/hris/payroll/pcb-two/PcbStatementContainerView'),
    },

    data () {
      return {
        tabItems: this.$hasPermissionTo(['view payroll pcb2']) ? [
          { name: 'Income Tax Reports' },
          { name: 'Audit Reports' },
          { name: 'PCB Statement' },
          { name: 'PCB Arrear' },
        ] : [
          { name: 'Reports' },
        ],
        active: 0,
        loading: false,
        years: [],
        companies: [],
        payrollPeriods: [],
        payrollReport: null,
        auditReport: null,
        payrollReportTypes: [
          { name: 'CP22' },
          { name: 'CP22A' },
          { name: 'CP8D' },          
          { name: 'Form E Data' },
          { name: 'PCB(II)' },
          { name: 'EA Form' },
          { name: 'Lampiran B' },
          { name: 'Previous Remuneration YTD (TP3) Reports' },          
        ],
        auditReportTypes: [
          { name: 'EPF Form A' }, 
          { name: 'SOCSO Form 8A' },
          { name: 'EIS Lampiran 1' },      
        ],
      }
    },
    created () {
      this.loading = true

      Promise.all([
        this.$api.payrollPeriods().list('?year=distinct'),
        this.$api.hrisCompanies().list(),
        this.$api.payrollPeriods().list(),
      ])
        .then(([years, companies, payrollPeriods]) => {
          this.years = years.data

          this.companies = _.orderBy(companies.data, ['name'], ['asc'])
          this.companies.unshift({ id: 'ALL', name: 'All Companies' })

          this.payrollPeriods = _.orderBy(
            payrollPeriods.data.filter(period => period.payroll_cycle_transactions.length > 0),
            ['payroll_date'],
            ['desc']
          )

          this.loading = false
        })
    },
  }
</script>
